export enum LoadType {
    QuadraticWithoutBreakaway,
    QuadraticWithBreakaway,
    Constant,
    Linear,
    NoLoad,
    Custom
}
